import React, { useContext, useState } from "react";
import { MDBRow } from 'mdbreact';
import { Grid, Row, Col } from "react-bootstrap";
import { Modal } from 'react-bootstrap';
import ButtonField from '../components/UI/Button/ButtonField';
import { PostAPI } from "api/post";
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert';
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import BeatLoader from "react-spinners/BeatLoader";
import Step1 from "components/Steps/Step1";
import Step2 from "components/Steps/Step2";
import Step3 from "components/Steps/Step3";
import useValidator from '../hooks/useValidator';
import 'assets/css/custom.css';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
let urlhost = window.location.host;
let urlprotocol = window.location.protocol;
let completeURL = urlprotocol + "//" +urlhost;


const RoleWizard = props => {
  const { t, i18n } = useTranslation();
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  let [currentStep, setcurrentStep] = useState(1);
  let [duplicateCheck, setDuplicateCheck] = useState(false);
  let [parentTableLength, setParentTableLength] = useState();
  let Components = {
    step1: Step1,
    step2: Step2,
    step3: Step3
  };
  let [disabledButton, setDisabledButton] = useState(false);
  let [formValues, setFormValues] = useState([]);
  let [tdDataParent, setTdDataParent] = useState([]);
  let [selectChildValueCheckbox, setSelectChildValueCheckbox] = useState([]);
  let [selectChildValueCheckboxExpanded, setSelectChildValueCheckboxExpanded] = useState([]);
  let [selectChildValue, setSelectChildValue] = useState([]);
  const [validator, showValidationMessage] = useValidator();
  const [showModal, setshowModal] = useState(false);
  let [modalType, setmodalType] = useState('Add');
  let [modalTitle, setmodalTitle] = useState('');
  let [modalActionURL, setmodalActionURL] = useState('');
  let [ModalformValues, setModalformValues] = useState();
  let [modalWidth, setModalWidth] = useState();
  let [CStep1, setCStep1] = useState();
  let [CStep2, setCStep2] = useState();
  let [CStep3, setCStep3] = useState();
  let [imageBinary, setImageBinary] = useState({});
  let [imageData, setImageData] = useState();
  let [imageSize, setImageSize] = useState();
   let [selectedCombo,setSelectedCombo] = useState();
   let [isLoader, setIsLoader] = useState(false)
  let arrayConvert = []
  let arrayConvert1 = [];
  let arrayConvert2 = [];
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const language = currentLanguageCode === 'en' ? 'english' : 'chinese'
  let dynamicParameters = {
    user_id:cookies.get('user_id'),
    customer_id:cookies.get('customer_id'),
    language:language
  }
  
  const close = () => {
    setshowModal(false);
  }

  const handleChildValueCheckbox = (clicked) => {
    setSelectChildValueCheckbox(clicked);
  }

  const handleChildValueCheckboxExpanded = (expanded) => {
    setSelectChildValueCheckboxExpanded(expanded);
  }

  const handleChildValueSelect = (val) => {
    setSelectChildValue(val);
  }
  
  const _next = () => {
    if (currentStep == 4 && parentTableLength == 0) {
      swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.add_level")}`, icon:"warning", button:`${t("alerts.ok")}`})
      }
    else if (validator.allValid()) {
     
    let currentStep1 = currentStep;
    currentStep1 = currentStep1 >= ((Object.keys(props.pageLayoutData.content.steps).length)-1)? (Object.keys(props.pageLayoutData.content.steps).length): currentStep1 + 1
    setcurrentStep(currentStep1); 
    }else if((currentStep == 4 && duplicateCheck === true)){
      let currentStep1 = currentStep;
      currentStep1 = currentStep1 >= ((Object.keys(props.pageLayoutData.content.steps).length)-1)? (Object.keys(props.pageLayoutData.content.steps).length): currentStep1 + 1
      setcurrentStep(currentStep1); 
    }else if((currentStep == 4 && duplicateCheck === false)){
      showValidationMessage(true);
    }
    else{
      showValidationMessage(true);
    }
  }
  
  const _prev = () => {
    let currentStep1 = currentStep
    currentStep1 = currentStep1 <= 1? 1: currentStep1 - 1
    setcurrentStep(currentStep1);
  }

  const previousButton = () => {
    let currentStep1 = currentStep;
    if(currentStep1 !==1){
      return (
        <ButtonField submit={_prev} color="info" BName={`${t('previous')}`} />
      )
    }
    return null;
  }

  const nextButton = () => {
    let currentStep1 = currentStep;
    if(currentStep1 < (Object.keys(props.pageLayoutData.content.steps).length)){
      return (
        <ButtonField submit={_next} color="danger" BName={`${t('next')}`} />     
      )
    }
    return(
      <button class="btn btn-outline-danger btn-rounded waves-effect"
      style={{borderRadius:'15px'}}
      disabled={disabledButton}
      onClick={ (e) => wizardSave(e)}>{`${t('save')}`}</button>
    )
  }

  const backFunction = e =>
  {
    props.setShowParentContent(true);
    setFormValues([]);
    setSelectChildValueCheckbox([]);
    setSelectChildValueCheckboxExpanded([]);
    setSelectChildValue([]);
    setTdDataParent([]);
  }
  
  const wizardSave = async (e) => {
    e.preventDefault();
    setIsLoader(true);
  if (validator.allValid()) {
    setDisabledButton(true);
    let wizard = {
      formValues: formValues,
      tdDataParent: tdDataParent,
      selectChildValueCheckbox: selectChildValueCheckbox,
      selectChildValue: selectChildValue
    };

    let requestData = '';
    let formData;

    if(formValues?.location)
    {
      if(formValues?.location !== null){
        formValues.location.map(function(fValue, indexId){
        arrayConvert1[indexId] = fValue.value;
      });
      formValues.location = arrayConvert1;
    }
    }
  if( Object.hasOwn( formValues, "warranty_period") && props.wizardTitle === "Products"){
      formValues.warranty_period = +formValues?.warranty_period ?? 0
  }  
    if (formValues?.category) {
      if (props.pageLayoutData.content.steps[1].formValues?.category["elementType"] === 'selectshowsearch') {
        let arrOfObj1 = Object.entries(formValues.category).map(entry => entry[1])
        formValues.category = arrOfObj1[0].toString()
      }
    }
    if (formValues.hasOwnProperty('component')) {
      if( formValues['product_type']==='8003' || formValues['product_type']==='8001'){
      formValues.component=null
      }
      else if (formValues?.component !==null && selectedCombo.visible ===false){
    if(formValues?.component !== null){
      formValues.component.map(function(fValue, indexId){
      arrayConvert2[indexId] = fValue.value;
    });
    formValues.component = arrayConvert2;
  }
}
      }
    if(selectChildValue)
    {
      selectChildValue.map(function(fValue, indexId){
             arrayConvert[indexId] = fValue.value;
           });
      selectChildValue = arrayConvert;
    }
    
    let combined = selectChildValueCheckbox.concat(selectChildValueCheckboxExpanded)
    let combinedUnique = combined.filter((item, pos) => combined.indexOf(item) === pos)
    let extraParameters = {
      feature_ids: combinedUnique,
      feature_ids_checked: selectChildValueCheckbox,
      feature_ids_expanded: selectChildValueCheckboxExpanded,
      assigned_users_id: arrayConvert,
      tbData:tdDataParent,
      created_from:'Website',
      customer_type:cookies.get('customer_id'),
      img: imageData,
      filename: imageBinary,
      filesize: imageSize,
      url: completeURL
    }
    if(props.commonTitle === "Product" || props.titlePreFix === `${t("edit")}`){
      requestData = {...formValues, ...dynamicParameters,
        extraParameters, id:props.uniqueId, formData}
      }else{
      requestData = {...formValues, ...dynamicParameters,
        extraParameters}
    }
    
    let url = props.addURL;
    PostAPI(url, requestData)
      .then(res => {
        if (res.status == 200){
          setIsLoader(false);
          if(res.data.data.status == 409) {
            swal(res.data.data.message, {
                icon: "error",
                timer: 2000,
                button: false
            });
            setDisabledButton(false);
          } else {
          swal({
            title: `${t("alerts.successfully_submitted")}`,
            icon: "success",
            timer: 1000,
            button: false
          })
          setDisabledButton(true);
          setTimeout(() => {
            props.recallMethod();
          }, 1000);

          setFormValues([]);
          setSelectChildValueCheckbox([]);
          setSelectChildValueCheckboxExpanded([]);
          setSelectChildValue([]);
          setTdDataParent([]);
          props.setShowParentContent(true);
         }
        }
        else {
          swal({
            title: "Not Success!",
            icon: "error",
            timer: 1000,
            button: false
          })
          setDisabledButton(false);
        }

      }).catch(function (error) {
      });
    }
    else
    {
      showValidationMessage(true);
    }
  }

  return (
  (props.pageLayoutData != 'undefined') ?
    <div className="content">
    <Grid fluid>
      <Row>
        <Col md={12} style={{backgroundColor:'#fbfbfb'}}>
        <Modal.Header>
                <Modal.Title>
                  { props.titlePreFix }
                  <a href='#!' className='font-weight-bold' style={{color:'#D54C2F'}}>
                    <strong> {props.wizardTitle}</strong>
                  </a>
                  <div style={{ float: 'right' }}>
                  {(!props.showParentContent) ? 
                    <ButtonField color="danger" key="Filter" submit={() => backFunction()} BName={`${t('back')}`} /> : ''}
                  </div>
                </Modal.Title>
              </Modal.Header>
              <ul className="breadcrumb" style={{marginLeft:'5px',marginBottom:'5px',marginTop:'10px'}}>       
                {props.pageLayoutData.content.steps.map(function(element, indexIdx){
                  return (
                    <li key={indexIdx} value={indexIdx}><a href="#" 
                    className={(currentStep===indexIdx+1)?'step-active':''}
                    >{element.id}</a></li> 
                  );
                })}   
              </ul>
                 
                <Modal.Body>
               
                {props.pageLayoutData.content.steps.map(block =>(
                  (typeof Components[block.component] != "undefined") ?
                    React.createElement(Components[block.component], {
                      key: block.id,
                      block: block,
                      titlePreFix:props.titlePreFix,
                      getDataURL:props.getURL,
                      futurename: props.featureName,
                      updtPageURL: props.updatePageDataURL,
                      currentStep: currentStep,
                      dropDwnApi: props.dropDwnApi,
                      setFormValues: setFormValues,
                      formValues: { ...formValues},
                      setTdDataParent: setTdDataParent,
                      tdDataParent: tdDataParent,
                      checkboxcheck: handleChildValueCheckbox,
                      checkboxexpand: handleChildValueCheckboxExpanded,
                      selectChildValueCheckbox: selectChildValueCheckbox,
                      setSelectChildValueCheckbox: setSelectChildValueCheckbox,
                      setSelectChildValue:setSelectChildValue,
                      selectChildValueCheckboxExpanded: selectChildValueCheckboxExpanded,
                      multiselection: handleChildValueSelect,
                      selectChildValue: selectChildValue,
                      validator: validator,
                      showValidationMessage: showValidationMessage,
                      thData: props.pageLayoutData.thData,
                      tdData: props.pageLayoutData.tdData,
                      dropDwnApi: props.dropDwnApi,
                      setImageSize: setImageSize,
                      imageSize: imageSize,
                      setImageData: setImageData,
                      setImageBinary: setImageBinary,
                      imagePath: props.imagePath,
                      duplicateCheck: duplicateCheck,
                      setDuplicateCheck: setDuplicateCheck,
                      parentTableLength: parentTableLength,
                      setParentTableLength: setParentTableLength,
                      setSelectedCombo : setSelectedCombo,
                    })
                  :
                  React.createElement(
                    () => <div>The component {block.component} has not been created yet.</div>,
                    { key: block.id }
                  )
                )
              )}   
                <MDBRow key="MDBROW1"></MDBRow>
                <MDBRow key="MDBROW2"></MDBRow> 
               </Modal.Body>         
              <div>
                <MDBRow className='d-flex align-items-center mb-4'>
                  <div className='text-center mb-3 row'>
                    {previousButton()}
                    {nextButton()}
                  </div>
                </MDBRow>
              </div>
              {isLoader===true&&<div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>} 
        </Col>
      </Row>
    </Grid>
    </div>
   : <div><BeatLoader size={15} margin={3} color={"#36d7b7"} /></div>
  );
}



export default RoleWizard;





















